module.exports = __webpack_public_path__ + "img/1920_stores_img1.bf1358a5.png";